// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"e8959d7d","487":"1b0871f4","707":"985fc01a"}[chunkId] + ".chunk.js";
};